import {MatrixClient, MatrixEvent} from 'matrix-js-sdk';

export const deleteSingleMessage = async (
  matrixClient: MatrixClient,
  eventToDelete: MatrixEvent
): Promise<MatrixEvent> => {
  try {
    const matrixEvent = eventToDelete.getEffectiveEvent();

    if (!matrixEvent.room_id || !matrixEvent.event_id) {
      throw new Error('No room id or event id found');
    }
    const {room_id, event_id} = matrixEvent;

    const deletionReason = `User deleted message`;

    await matrixClient.redactEvent(room_id, event_id, undefined, {
      reason: deletionReason
    });

    const deletedEvent = eventToDelete;

    return deletedEvent;
  } catch (error) {
    console.error('Failed to redact the event:', error);
    throw error;
  }
};
